// function unicodeToChar(text) {
//   if (text) {
//     return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
//       return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
//     });
//   }
// }

function unicodeToChar(text, oldTreatement = false) {
  if (oldTreatement) {
    if (text) {
      return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
      });
    }
  }
  if (!oldTreatement) {
    if (text) {
      return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        const char = String.fromCharCode(
          parseInt(match.replace(/\\u/g, ""), 16),
        );
        if (char === "<") return "&lt;";
        if (char === ">") return "&gt;";
        if (char === "&") return "&amp;";
        return char;
      });
    }
  }
}

export default unicodeToChar;
